window.$ = window.jQuery = require('jquery');

import Swiper from 'swiper';
import Swal from 'sweetalert2';

var $window = $(window),
    $body   = $('body');

var fn = {

	/*
		Launch
	*/

	Launch: function () {
        fn.Navigation();
        fn.Carousels();
        fn.Search();
        fn.Alerts();
        fn.App();
	},

    /*
        Navigation
    */

    Navigation: function() {

        $body.append('<div class="layer layer--megamenu"></div>');

        $body.on('click', '[data-menu-toggle]', function(e) {
            e.preventDefault();

            $('.menu').toggleClass('menu--active');
            $body.toggleClass('layer--global-active');
            $body.removeClass('layer--search-active');
        });

        var $navTitle    = $('[data-nav-title]'),
            $hasMegamenu = $('.has-megamenu'),
            lgAndDown    = window.matchMedia("(max-width: 1199px)");

        function navigation(x) {
            if (x.matches) {
                // Megamenu
                
                $body.on('click', '[data-open-child]', function(e) {
                    e.preventDefault();

                    var $this     = $(this),
                        $menuItem = $this.closest('[data-parent]');

                    $this.closest('.megamenu').find('[data-nav-back]').removeClass('megamenu-close');

                    $menuItem.addClass('mobile-active');

                    $navTitle.html($this.text());
                });

                $body.on('click', '[data-nav-back]', function(e) {
                    e.preventDefault();

                    var $this = $(this);

                    $('.mobile-active').last().removeClass('mobile-active');

                    if($('.mobile-active').last().length) {
                        $navTitle.html($('.mobile-active').last().find('> a').text());
                    } else {
                        $this.addClass('megamenu-close');
                        $navTitle.html($navTitle.data('nav-title'));
                    }
                });

                $body.on('click', '.megamenu-close', function(e) {
                    e.preventDefault();

                    $(this).closest('.megamenu-active').removeClass('megamenu-active');
                });

                $body.on('click', '.has-megamenu > a', function(e) {
                    e.preventDefault();

                    $(this).closest('.has-megamenu').addClass('megamenu-active');
                });

                $body.on('click', '[data-open-megamenu]', function(e) {
                    e.preventDefault();

                    $body.addClass('show-megamenu');
                });

                $body.on('click', '[data-nav-close]', function(e) {
                    e.preventDefault();

                    $body.removeClass('show-megamenu');
                });
            }
        }

        navigation(lgAndDown);

        lgAndDown.addListener(navigation);

        // Categories
        
        $body.on('click', '.category-selector [data-parent] > a', function(e) {
            e.preventDefault();

            var $this = $(this);

            $this.closest('.category-selector').addClass('active');
            $('[data-parent].active').addClass('hide');
            $this.closest('li').addClass('active');

            $('[data-back] span').html($this.text());
        });

        $body.on('click', '.category-selector [data-back] > a', function(e) {
            e.preventDefault();

            var $this = $(this);

            $('[data-parent].active').last().removeClass('active');
                $('[data-parent].active.hide').last().removeClass('hide');

            if($('[data-parent].active').length != 1) {
                $('[data-back] span').html($('[data-parent].active').last().find('> a').text());
            } else {
                $this.closest('.category-selector').removeClass('active');
                $('[data-back] span').html($('[data-back]').data('nav-title'));
            }
        });
        
        // Desktop menu

        $hasMegamenu.on('mouseover', function(e) {
            e.preventDefault();

            $body.addClass('layer--megamenu-active');
        });

        $hasMegamenu.on('mouseout', function(e) {
            e.preventDefault();

            $body.removeClass('layer--megamenu-active');
        });

        $('.megamenu > ul > li').on('mouseover', function(e) {
            e.preventDefault();

            var $this = $(this);

            $this.closest('ul').find('li').removeClass('active');
            $this.addClass('active');
        });

    },

    /*
        Carousels
    */

    Carousels: function() {

        new Swiper('.hero__bg', {
            loop: true,
            slidesPerView: 1,
            effect: 'fade',
            speed: 3000,
            autoplay: {
                delay: 3000,
            },
        });

        new Swiper('.person-carousel--boxed', {
            loop: false,
            slidesPerView: 4,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                992: {
                    slidesPerView: 'auto',
                },
            },
        });

    },

    /*
        Search
    */

    Search: function() {

        $('.inline-search').after('<div class="layer layer--search"></div>');
        $body.append('<div class="layer layer--global"></div>');

        $('[data-search-open]').on('click', function(e) {
            e.preventDefault();

            $body.addClass('layer--search-active');
            $body.removeClass('layer--global-active');
            $('.menu').removeClass('menu--active');
        });

        $body.on('click', '[data-search-close]', function(e) {
            e.preventDefault();

            $body.removeClass('layer--search-active');
            $('.inline-search').removeClass('inline-search--active');
            $('.inline-search .form-control').val('');
        });

        $body.on('click', '.inline-search .form-control', function(e) {
            e.preventDefault();

            $body.addClass('layer--search-active');
        });

        $body.on('keyup', '.inline-search .form-control', function(e) {
            e.preventDefault();

            var $input = $(this),
                $form  = $input.closest('.inline-search');

            if($input.val().length > 0) {
                $form.addClass('inline-search--active');
            } else {
                $form.removeClass('inline-search--active');
            }
        });
    },

    /*
		Alerts
	*/

	Alerts: function () {

        $body.on('click', '[data-add-to-cart]', function(e) {
            e.preventDefault();

            $.ajax({
                url: $(e.target).attr('data-url'),
                data: {
                    'ajax': 1,
                },
                success: function (result) {
                    if (result.size > 0) {
                        $("#cart-num").html(result.size);
                    }

                    Swal.fire({
                        icon: 'success',
                        html: '<strong>A terméket kosárba raktuk</strong>',
                        showCancelButton: true,
                        focusConfirm: false,
                        buttonsStyling: false,
                        confirmButtonText: 'Tovább nézelődök',
                        cancelButtonText: 'Ajánlat kérés leadása',
                        customClass: {
                            confirmButton: 'btn btn-outline-primary',
                            cancelButton: 'btn btn-primary',
                        }
                    }).then(function(res) {
                        if(res.dismiss == 'cancel'){
                            window.location.href = "kosar";
                        }
                    });

                }
            });
        });

    },

    /*
		App
	*/

	App: function () {

        $('[data-toggle-type]').on('change', function() {
            var $btn  = $(this),
                id    = $btn.attr('id');

            $('[data-toggle-show-if]').each(function() {
                var $item  = $(this),
                    values = $item.data('toggle-show-if').split('|');
                    
                if(values.indexOf(id) != -1) {
                    $item.removeClass('d-none');
                } else {
                    $item.addClass('d-none');
                }
            });
        });

        $('[data-categories-open]').on('click', function(e) {
            e.preventDefault();

            $('.category-wrapper').removeClass('d-none'); 
            $body.addClass('overflow-hidden');
        });

        $('[data-categories-close]').on('click', function(e) {
            e.preventDefault();

            $('.category-wrapper').addClass('d-none'); 
            $body.removeClass('overflow-hidden');
        });

        // On Scroll

    	$window.on('scroll', function() {
    		var $this            = $(this),
    			scrollPx         = $this.scrollTop(),
                $header          = $('.header');

    		// Header

    		if(scrollPx > 50) {
    			$header.addClass('header--sticky');
    		} else {
    			$header.removeClass('header--sticky');
    		}

    	}).trigger('scroll');

    },

};

let searchTimer;
$('#search-string').keyup(function(ev) {
    if (ev.keyCode != 27 && $('#search-string').val() != '') {
        ev.preventDefault();
        if (searchTimer) {
            clearTimeout(searchTimer)
        }
        searchTimer = setTimeout(function() {
            $.ajax({
                url: '/ajax-search',
                data: {
                    q: $('#search-string').val()
                },
                success: function(result) {
                    $('#searchres').html(result);
                }
            })
        }, 300)
    }
});

fn.Launch();

$(document).ready(function () {
    $(".delivery-radio").change(function() {
        if(this.value == 1) {
            $(".delivery-info").show();
            $('.shipping').val(1);
        }
        else {
            $(".delivery-info").hide();
            $('.shipping').val(0);
        }
    });

    function validateField(field, val) {
        $.ajax({
            url: '/cart/validate',
            data: {
                field: field,
                val: val,
                shipping: $('.shipping').val(),
            }
        }).always(function (data) {
            $("input[name='" + field + "'], textarea[name='" + field + "']").removeClass('error');
            $("input[name='" + field + "'], textarea[name='" + field + "']").removeClass('success');
            $('.msg-' + field).html('');
            if (data) {
                $.each(data.responseJSON, function (key, value) {
                    $("input[name='" + key + "'], textarea[name='" + key + "']").addClass('error');
                    $('.msg-' + key).append('<span>' + value[0] + '</span>');
                });
            } else {
                $("input[name='" + field + "'], textarea[name='" + field + "']").addClass('success');
            }
        });
    }

    function validate() {
        $.ajax({
            url: '/cart/validate?save=1',
            method: 'POST',
            data: $('.order-form').serialize()
        }).always(function (data) {
            $("form input, form textarea, li").removeClass('error').removeClass('success');
            $(".validate-msg").html('');
            len = 0;
            if (data) {
                var len = $.map(data.responseJSON.errors, function (n, i) {
                    return i;
                }).length;
            }

            if (len > 0) {
                $('#order-error div p').empty();
                $.each(data.responseJSON.errors, function (key, value) {
                    $("input[name='" + key + "'], textarea[name='" + key + "']").addClass('error');
                    $('.msg-' + key).append('<span>' + value + '</span>');
                    $('#order-error div p').append(value + '<br />');
                });

                var inst = $('[data-remodal-id=order-error]').remodal();

                inst.open();
            }
            else {
                $('.order-form').submit();
            }

            $('.form__input:has(.validate):not(.success,.error)').addClass('success');
        });
    }

    $('.order-form button:submit').click(function (event) {
        event.preventDefault();
        validate();
    });

    $("body").on("blur", 'input.validate', function (e) {
        validateField($(this).attr('name'), $(this).val());
    });

    refreshQuantity();
});



